export default __webpack_public_path__ + "static/media/africa.5d65a02a.jpg";